import { createContext, useContext, useState, useEffect } from "react";

const CurrencyContext = createContext(null);

export function CurrencyProvider({ children }) {
  const [base, setBase] = useState(() => localStorage.getItem("finakis_base") || "TRY");
  const [month, setMonth] = useState(() => localStorage.getItem("finakis_month") || "all");

  useEffect(() => {
    localStorage.setItem("finakis_base", base);
  }, [base]);

  useEffect(() => {
    localStorage.setItem("finakis_month", month);
  }, [month]);

  const monthQuery = month === "all" ? "" : `month=${month}`;

  return (
    <CurrencyContext.Provider value={{ base, setBase, month, setMonth, monthQuery }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyContext);
